import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Select, MenuItem } from '@material-ui/core'
import { TASK_STATUS, TASK_STATUS_LABELS, TASK_STATUS_COLORS } from '../../constants/bidStatuses'

const ModuleStatusSelect = ({ moduleId, status, url, onChange }) => {
  const handleChange = (e) => {
    const newStatus = e.target.value
    onChange(moduleId, newStatus)
    axios.put(`${url}/api/bid-estimation/modules/${moduleId}/status`, { status: newStatus })
      .catch(err => {
        console.error('Module status update failed:', err)
        onChange(moduleId, status) // revert
      })
  }

  return (
    <Select
      value={status}
      onChange={handleChange}
      onClick={(e) => e.stopPropagation()}
      disableUnderline
      style={{ fontSize: 11 }}
      renderValue={(val) => (
        <span style={{
          backgroundColor: TASK_STATUS_COLORS[val] || '#9e9e9e',
          color: '#fff', padding: '2px 8px', borderRadius: 10, fontSize: 11
        }}>
          {TASK_STATUS_LABELS[val] || val}
        </span>
      )}
    >
      {Object.values(TASK_STATUS).map(s => (
        <MenuItem key={s} value={s} style={{ fontSize: 12 }}>
          {TASK_STATUS_LABELS[s]}
        </MenuItem>
      ))}
    </Select>
  )
}

const mapStateToProps = (state) => ({
  url: state.url
})

export default connect(mapStateToProps)(ModuleStatusSelect)
